// extracted by mini-css-extract-plugin
export var cartIcon = "_on-0";
export var cartIconContainer = "_on-1";